import { render, staticRenderFns } from "./TheProject.vue?vue&type=template&id=485e527f&scoped=true"
import script from "./TheProject.vue?vue&type=script&lang=js"
export * from "./TheProject.vue?vue&type=script&lang=js"
import style0 from "./TheProject.vue?vue&type=style&index=0&id=485e527f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485e527f",
  null
  
)

export default component.exports